import { DateTime } from 'luxon'

export function calculateDuration(
  arrival: string | Date,
  departure?: string | Date
): string {
  const startTime = DateTime.fromISO(arrival.toString())
  // If departure is not provided, calculate duration until now for ongoing visits
  const endTime = departure
    ? DateTime.fromISO(departure.toString())
    : DateTime.now()

  // Ensure diff is non-negative
  const diff = endTime.diff(startTime, ['hours', 'minutes'])

  const hours = Math.floor(diff.hours)
  const minutes = Math.floor(diff.minutes)

  if (hours === 0) {
    return `${minutes}m`
  }
  return `${hours}h ${minutes}m`
}

export function formatTime(
  dateInput: string | Date | undefined,
  placeholder: string = '---'
): string {
  if (!dateInput) {
    return placeholder
  }
  return DateTime.fromISO(dateInput.toString()).toFormat('HH:mm')
}
